import type { WeekDay } from '@acceligentllc/shared/enums/weekDay';
import { weekDays } from '@acceligentllc/shared/enums/weekDay';

interface WorkDayData {
	id: number;
	companyId: number;
	weekDay: WeekDay;
}
export const convertWorkDays = (workDays: WorkDayData[] | undefined = []) => {
	const workingWeekDays = workDays.map((_wd) => _wd.weekDay);
	return weekDays.map((_wd) => ({ [_wd.toLowerCase()]: workingWeekDays.includes(_wd) })).reduce((acc, _wd) => ({ ...acc, ..._wd }), {});
};
